import { render } from "./stage1.vue?vue&type=template&id=7a83d336&scoped=true"
import script from "./stage1.vue?vue&type=script&lang=js"
export * from "./stage1.vue?vue&type=script&lang=js"

import "./stage1.vue?vue&type=style&index=0&id=7a83d336&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a83d336"]])

export default __exports__